<div [formGroup]="formGroup">
  <sc-flex >
    <mat-form-field>
      <input matInput [formControlName]="formControlName" readonly="{{disabled}}" [required]="!disabled"
              placeholder="{{'numberplate' | translate: [labelInput, translationService.language]}}"
              minlength="row.minLength" maxlength="255" />
    </mat-form-field>
    <sc-content-spacer [half]="true"></sc-content-spacer>
    <mat-checkbox (change)="withoutFahrzeug($event)">
      {{'No vehicle' | translate: [labelCheckbox, translationService.language]}}
    </mat-checkbox>
  </sc-flex>
</div>
